import { render, staticRenderFns } from "./Questionsetting.vue?vue&type=template&id=ca4a3888&scoped=true&"
import script from "./Questionsetting.vue?vue&type=script&lang=js&"
export * from "./Questionsetting.vue?vue&type=script&lang=js&"
import style0 from "./Questionsetting.vue?vue&type=style&index=0&id=ca4a3888&scoped=true&lang=scss&"
import style1 from "./Questionsetting.vue?vue&type=style&index=1&id=ca4a3888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4a3888",
  null
  
)

export default component.exports